export const appBaseURL = "https://qitqa.auruminstitute.org";
export const keyCloakBaseURL = "https://devops.auruminstitute.org:8444";
export const downloadURL = "/api/file/downloadFile?externalReference=";
